!(function () {
  const t = document.querySelectorAll(".main-product__content"),
    e = document.querySelector(".sticky-add-to-cart");
  let n = null,
    u = null,
    c = null;
  t.forEach((t) => {
    (n = t.querySelector('button[name="plus"]')),
      (u = t.querySelector('button[name="minus"]')),
      (c = t.querySelector('input[name="quantity"]')),
      e &&
        ((qtyPlusSticky = e.querySelector('button[name="plus"]')),
        (qtyMinusSticky = e.querySelector('button[name="minus"]')),
        (qtyInputSticky = e.querySelector('input[name="quantity"]')));
    const i = (n) => {
      (t.querySelector(".quantity input").value = n),
        (t.querySelector("#quantity").value = n),
        e &&
          ((e.querySelector(".quantity input").value = n),
          (e.querySelector("#quantity").value = n));
    };
    if (t.querySelector(".quantity input") && t.querySelector("#quantity")) {
      let r = parseInt(t.querySelector("#quantity").value);
      n.addEventListener("click", function () {
        (r += 1), i(r);
      }),
        u.addEventListener("click", function () {
          r > 1 && ((r -= 1), i(r));
        }),
        c.addEventListener("change", function (t) {
          parseInt(t.target.value) > 0 && (r = parseInt(t.target.value)), i(r);
        }),
        c.addEventListener("keypress", function (t) {
          ((8 !== t.which && 0 !== t.which && t.which < 48) || t.which > 57) &&
            t.preventDefault();
        }),
        e &&
          qtyPlusSticky &&
          qtyMinusSticky &&
          qtyInputSticky &&
          (qtyPlusSticky.addEventListener("click", function () {
            (r += 1), i(r);
          }),
          qtyMinusSticky.addEventListener("click", function () {
            r > 1 && ((r -= 1), i(r));
          }),
          qtyInputSticky.addEventListener("change", function (t) {
            parseInt(t.target.value) > 0 && (r = parseInt(t.target.value)),
              i(r);
          }),
          qtyInputSticky.addEventListener("keypress", function (t) {
            ((8 !== t.which && 0 !== t.which && t.which < 48) ||
              t.which > 57) &&
              t.preventDefault();
          }));
    }
  });
})();
